import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "article",
    {
      staticClass: "lpu-card w-100",
      class: {
        "lpu-card--special-placement pa-2 pa-sm-3":
          _setup.showPerCardSpecialPlacement,
        "lpu-card--ultima":
          _vm.isUltima &&
          !_vm.isSpecialPlacement &&
          _setup.context.request.feature_flags.allow_ultima,
        "bg-gray-0": !_setup.showPerCardSpecialPlacement && !_vm.isUltima,
      },
      attrs: {
        "data-qa": "analyses_lpu_card",
        "data-qa-lpu-id": _vm.id,
        "data-schedule-item": _vm.scheduleItemJson,
        "data-club-is-enabled-lpu": _vm.isClubDiscountEnabled
          ? "true"
          : "false",
        "data-special-placement": _vm.isSpecialPlacement ? "1" : undefined,
      },
    },
    [
      _setup.showPerCardSpecialPlacement
        ? _c(
            "div",
            {
              staticClass:
                "lpu-card__special-label text-caption text-center text-no-wrap",
              attrs: { "data-qa": "analyses_lpu_card_special_label" },
            },
            [_vm._v("\n    Спецразмещение\n  ")]
          )
        : _vm.isUltima && _setup.context.request.feature_flags.allow_ultima
        ? _c(
            "div",
            {
              staticClass:
                "lpu-card__ultima-label d-flex align-center pl-4 text-caption text-no-wrap",
              attrs: { "data-qa": "analyses_lpu_card_ultima_label" },
            },
            [_vm._v("\n    Ультима\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "lpu-card__body d-flex flex-column flex-sm-row align-center align-sm-start ga-4 w-100 min-w-0 pa-4 pa-sm-6",
          class: {
            "bg-gray-0":
              _setup.showPerCardSpecialPlacement ||
              (_vm.isUltima &&
                _setup.context.request.feature_flags.allow_ultima),
          },
        },
        [
          _c("div", { staticClass: "lpu-card__aside" }, [
            _c(
              "a",
              {
                staticClass:
                  "lpu-card__logo-wrap lpu-card__order-logo position-relative w-100",
                attrs: { href: _vm.href },
              },
              [
                _setup.ff_update_lpu_logo && !_vm.closed
                  ? _c(_setup.LpuLogoPicture, {
                      attrs: {
                        "img-class": "lpu-card__logo",
                        "data-qa": "analyses_lpu_card_logo",
                        contain: "",
                        files: _vm.logoFiles,
                        alt: _vm.logoAlt,
                      },
                    })
                  : _setup.ff_update_lpu_logo
                  ? _c("img", {
                      staticClass: "lpu-card__logo",
                      attrs: {
                        "data-qa": "analyses_lpu_card_logo",
                        src: _vm.logoUrl,
                        alt: _vm.logoAlt,
                      },
                    })
                  : _c(VImg, {
                      staticClass: "lpu-card__logo",
                      attrs: {
                        "data-qa": "analyses_lpu_card_logo",
                        src: _vm.logoUrl,
                        alt: _vm.logoAlt,
                        contain: "",
                      },
                    }),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.closed
              ? _c(
                  "div",
                  { staticClass: "lpu-card__meta lpu-card__order-meta" },
                  [
                    _c(_setup.LpuCardRating, {
                      attrs: {
                        rating: _vm.rating,
                        "reviews-count": _vm.reviewsCount,
                        "reviews-href": _vm.reviewsHref,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isAwardWinner || _vm.lpuLoyaltyProgram
              ? _c(
                  "div",
                  {
                    staticClass:
                      "lpu-card__badges lpu-card__order-badges d-flex flex-column align-center ga-2 w-100",
                  },
                  [
                    _vm.isAwardWinner
                      ? _c(_setup.AwardWinner, {
                          attrs: {
                            type: "lpu",
                            "redirect-url":
                              _vm.awardRedirectUrl || _vm.lpuPageHref,
                            "current-award-year": _vm.currentAwardYear || 0,
                            "is-award-or-grand-prix-winner": Boolean(
                              _vm.isAwardWinner
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.lpuLoyaltyProgram
                      ? _c(_setup.LpuLoyaltyProgram, {
                          attrs: {
                            "bonus-levels": _vm.lpuLoyaltyProgram.levels,
                            "max-payment-percent":
                              _vm.lpuLoyaltyProgram.max_payment_percent,
                            "use-label": "",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "lpu-card__main" }, [
            _c(
              "div",
              {
                staticClass:
                  "lpu-card__head lpu-card__order-head d-flex flex-column align-center align-sm-start ga-1 min-w-0 text-center text-sm-left",
              },
              [
                _c(
                  "div",
                  { staticClass: "lpu-card__name text-h6" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "text--text text-decoration-none",
                        attrs: {
                          "data-qa": "analyses_lpu_card_name",
                          href: _vm.href,
                        },
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(_vm.name) + "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.license
                      ? _c(_setup.LpuLicenseBadge, {
                          attrs: {
                            qa: "analyses_lpu_card_verified_badge",
                            text: `Лицензия клиники: ${_vm.license}`,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "text-body-2 text-secondary--text",
                    attrs: { "data-qa": "analyses_lpu_card_type" },
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm.lpuTypeName) + "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.closed
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "lpu-card__closed-alert d-inline-flex align-center gc-2 py-2 px-3 rounded bg-warning",
                        attrs: { "data-qa": "analyses_lpu_card_closed_alert" },
                      },
                      [
                        _c("span", {
                          staticClass:
                            "ui-icon-circle-warning ui-icon-fz-medium flex-shrink-0",
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-body-2 text--text" }, [
                          _vm._v(
                            "\n            Клиника больше не работает\n          "
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "lpu-card__content lpu-card__order-content d-flex flex-column ga-4 min-w-0 w-100 text-left",
              },
              [
                _c("div", { staticClass: "d-flex flex-column ga-3" }, [
                  _vm.analysesCount
                    ? _c("div", { staticClass: "d-flex align-center gc-2" }, [
                        _c("span", {
                          staticClass:
                            "ui-icon-laba ui-icon-fz-medium icon-secondary--text flex-shrink-0",
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "text-body-2 text--text",
                            attrs: {
                              "data-qa": "analyses_lpu_card_analyses_count",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_setup.analysesCountText) +
                                "\n            "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex align-start gc-2" }, [
                    _c("span", {
                      staticClass:
                        "ui-icon-map-pin ui-icon-fz-medium icon-secondary--text flex-shrink-0",
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "text-body-2 text--text",
                        attrs: { "data-qa": "analyses_lpu_card_address" },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.address) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.metros.length
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "lpu-card__metros d-flex flex-column ga-2",
                        },
                        _vm._l(_vm.metros, function (metro, index) {
                          return _c(
                            "div",
                            {
                              key: `${metro.name}-${index}`,
                              staticClass: "d-inline-flex align-center gc-2",
                              attrs: { "data-qa": "analyses_lpu_card_metro" },
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "lpu-card__metro-dot flex-shrink-0",
                                style: { backgroundColor: metro.color },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "text-caption text--text" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(metro.name) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-caption text-secondary--text",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(metro.distance) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.scheduleText
                    ? _c("div", { staticClass: "d-flex align-start gc-2" }, [
                        _c("span", {
                          staticClass:
                            "ui-icon-clock ui-icon-fz-medium primary--text flex-shrink-0",
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(_setup.LpuCardSchedule, {
                              attrs: {
                                "schedule-text": _vm.scheduleText,
                                "address-id": _vm.scheduleAddressId,
                              },
                            }),
                            _vm._v(" "),
                            _vm.closingTimeText
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-body-2 text-warning--text",
                                    attrs: {
                                      "data-qa":
                                        "analyses_lpu_card_closing_time",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.closingTimeText) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.phone
                    ? _c("div", { staticClass: "d-flex align-center gc-2" }, [
                        _c("span", {
                          staticClass:
                            "ui-icon-phone-call ui-icon-fz-medium icon-secondary--text flex-shrink-0",
                          class: _setup.isMobile ? "primary--text" : "",
                        }),
                        _vm._v(" "),
                        _setup.isMobile
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "text-body-2 primary--text text-decoration-none",
                                attrs: {
                                  "data-qa": "analyses_lpu_card_phone",
                                  href: `tel:${_vm.phone}`,
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.phone) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _c(
                              "span",
                              {
                                staticClass: "text-body-2 text--text",
                                attrs: { "data-qa": "analyses_lpu_card_phone" },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.phone) +
                                    "\n            "
                                ),
                              ]
                            ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.isActiveClubDiscount && _setup.hasWindow
                  ? _c(
                      "div",
                      {
                        staticClass: "vue-club-service-discount-control",
                        attrs: { "data-qa": "analyses_lpu_card_club_discount" },
                      },
                      [
                        _c(_setup.ClubServiceDiscountControl, {
                          tag: "component",
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass: "b-card-services__calendar-selects",
                  attrs: { "data-qa": "lpu_card_calendar_selects" },
                }),
                _vm._v(" "),
                _vm.isSuperuser && _vm.bidPlacement?.adminUrl
                  ? _c(
                      "div",
                      { attrs: { "data-qa": "analyses_lpu_card_sp_links" } },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "adminka",
                            attrs: {
                              href: _vm.bidPlacement.adminUrl,
                              target: "_blank",
                              rel: "noopener noreferrer",
                            },
                          },
                          [
                            _vm._v(
                              "\n            Ставка(" +
                                _vm._s(_vm.bidPlacement.bid) +
                                ")\n            - Место(" +
                                _vm._s(_vm.bidPlacement.place) +
                                ")\n            - Оплата(" +
                                _vm._s(_vm.bidPlacement.paymentSumma ?? "-") +
                                ")\n          "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.reviewsSummary
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "lpu-card__reviews-summary d-flex flex-column gr-1 pa-3 px-4 rounded-lg bg-secondary",
                        attrs: {
                          "data-qa": "analyses_lpu_card_reviews_summary",
                        },
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "text-body-2 text-secondary--text mb-0",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.reviewsSummary) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _setup.hasPriceItems
                  ? _c(
                      "div",
                      {
                        staticClass: "lpu-card__prices",
                        attrs: { "data-qa": "analyses_lpu_card_prices" },
                      },
                      [
                        _c(
                          "div",
                          {
                            attrs: {
                              "data-qa": "service_card_first_three_items",
                            },
                          },
                          _vm._l(
                            _setup.visiblePriceItems,
                            function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: `price-visible-${index}`,
                                  staticClass:
                                    "d-flex justify-space-between mt-2",
                                  attrs: {
                                    "data-qa": "service_card_price_item",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-body-2 text-break text--text",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(item.name) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-body-2 text-secondary--text ml-6 text-no-wrap",
                                    },
                                    [
                                      item.withPreposition
                                        ? [_vm._v("от ")]
                                        : _vm._e(),
                                      _vm._v(
                                        _vm._s(item.price) + "\n              "
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                        _vm._v(" "),
                        _setup.hiddenPriceItems.length
                          ? [
                              !_setup.isPricesExpanded
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "lpu-card__prices-expand text-body-2 text-decoration-underline text-secondary--text mt-1",
                                      attrs: {
                                        type: "button",
                                        "data-qa":
                                          "analyses_lpu_card_prices_expand",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _setup.isPricesExpanded = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Все цены (" +
                                          _vm._s(_setup.priceItemsTotal) +
                                          ")\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _setup.isPricesExpanded,
                                      expression: "isPricesExpanded",
                                    },
                                  ],
                                  attrs: {
                                    "data-qa": "service_card_price_list",
                                  },
                                },
                                _vm._l(
                                  _setup.hiddenPriceItems,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: `price-hidden-${index}`,
                                        staticClass:
                                          "d-flex justify-space-between mt-2",
                                        attrs: {
                                          "data-qa": "service_card_price_item",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-body-2 text-break text--text",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(item.name) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-body-2 text-secondary--text ml-6 text-no-wrap",
                                          },
                                          [
                                            item.withPreposition
                                              ? [_vm._v("от ")]
                                              : _vm._e(),
                                            _vm._v(
                                              _vm._s(item.price) +
                                                "\n                "
                                            ),
                                          ],
                                          2
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "d-flex align-start gc-1" }, [
      _c("span", {
        staticClass:
          "ui-icon-message-circle-fill ui-icon-fz-medium primary--text flex-shrink-0",
      }),
      _vm._v(" "),
      _c("span", { staticClass: "text-subtitle-2 text--text" }, [
        _vm._v("\n              Цитата из отзыва\n            "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }